<template>
	<div class="colour-pick">
			<swatches
				v-model="form[id]"
				colors="text-advanced"
				show-fallback
				fallbackInputClass='custom-colour-fallback'
				fallback-input-type="color"
				popover-to="left"
				row-length=10
				swatch-size='32'
				:swatch-style="{ borderRadius: '10px', padding: '16px 10px' }"
			>
			</swatches>
		</div>
</template>

<script>
import Swatches from 'vue-swatches'

export default {
	components: { Swatches },
	props: [ 'form', 'id' ],
}
</script>

<style lang="scss">
.colour-pick {
	margin-bottom: 40px;
	.vue-swatches__trigger {
		margin-bottom: 10px;
	}
	.vue-swatches__fallback__wrapper {
		margin-top: 5px;
		.vue-swatches__fallback__button {
			height: 20px;
			border-radius: 5px;
			border: none;
			width: 18%;
			height: 40px;
			vertical-align: middle;
		}
		.vue-swatches__fallback__input--wrapper {
			input {
				border-radius: 5px;
				border: none;
				width: 80%;
				height: 40px;
				vertical-align: middle;
			}
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Form/ColourPicker.vue